import { useState } from "react";

export const useUpdatePassStates = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  //const [passwordConfirmError, setPasswordConfirmError] = useState("");

  // 更新ボタン有効フラグ
  const [isActiveUpdateButton, setIsActiveUpdateButton] = useState(false);

  return {
    oldPassword,
    setOldPassword,
    newPassword,
    setNewPassword,
    confirmNewPassword,
    setConfirmNewPassword,
    passwordError,
    setPasswordError,
    //passwordConfirmError,
    //setPasswordConfirmError,
    isActiveUpdateButton,
    setIsActiveUpdateButton,
  };
};
